export async function copyToClipboard(copyText: string) {
  return new Promise<void>((resolve, reject) => {
    try {
      navigator.clipboard.writeText(copyText);
      resolve();
    } catch (error) {
      console.error(error);
      reject();
    }
  });
}
